export default __webpack_public_path__ + "static/media/BrainBreak cards102.f3633898.png";